import { xmlSafeText } from 'utils/XmlSafeTextUtil'

const transcriptCleaner = (body) => {
  if ( body === null || body === undefined || body === 0 ) return null;

  // Carriage returns are dropped outright so CRLF sources normalise to \n.
  // Everything else XML rejects is handled by the shared sanitizer, which keeps
  // the stored body safe to write into a .docx export later.
  const other = xmlSafeText(body.replace(/\r/g, ''));

  return other;
}

export default transcriptCleaner;
